import { ElementStatus, PackageFeatureResource, PackageResource, PluginRequirement } from '../http/api'
import { RequiredEntitiesType } from '../http/services'

export function selectRequiredDependeciesByType(
    dependencies: PackageResource['requiredEntities'],
    type: RequiredEntitiesType
) {
    if (!dependencies) {
        return []
    }

    return dependencies.filter(feature => {
        return feature.type === type
    })
}

export function selectPluginDependencies(requiredPlugins: PackageResource['requiredPlugins']): PluginRequirement[] {
    return (
        requiredPlugins?.map(({ name, version, optional }) => ({
            name,
            version,
            optional
        })) ?? []
    )
}

export function thereAreDependencies(pkg: PackageResource): boolean {
    const dependencies = selectPluginDependencies(pkg.requiredPlugins)
    const channels = selectRequiredDependeciesByType(pkg.requiredEntities, 'IDENTIFIED_CHANNEL')

    return !_.isEmpty(dependencies) || !_.isEmpty(channels)
}

export const getRequiredEntitiesValidationStatus = (entity: PackageResource['requiredEntities'][0]): ElementStatus => {
    return entity.state?.status
}

export const getFeatureValidationStatus = (pkgEnabled: boolean, feature: PackageFeatureResource): ElementStatus => {
    if (!pkgEnabled && feature.enabled) {
        return 'INACTIVE'
    }

    return feature.status?.flags?.includes('INVALID') ? 'INVALID' : 'VALID'
}

export const getPackageValidationStatus = (pkg: PackageResource): ElementStatus => {
    if (!pkg) {
        return null
    }

    let status =
        pkg.status?.flags?.includes('INVALID') ||
        pkg.pluginState?.status === 'INVALID' ||
        // @ts-ignore
        pkg.pluginState?.status === 'UNKNOWN'
            ? 'INVALID'
            : 'VALID'

    if (pkg.features?.some(feature => feature.status?.flags?.includes('INVALID'))) {
        status = 'INVALID'
    }

    return status as ElementStatus
}

export const getPackageDisplayStatus = (pkg: PackageResource) => {
    const status = getPackageValidationStatus(pkg)
    if (status == 'VALID') {
        return pkg.enabled ? 'ENABLED' : 'DISABLED'
    }

    return status
}
